/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFileTypeVue = createReactComponent("file-type-vue", "IconFileTypeVue", [
  ["path", { d: "M14 3v4a1 1 0 0 0 1 1h4", key: "svg-0" }],
  ["path", { d: "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4", key: "svg-1" }],
  ["path", { d: "M4 15l2 6l2 -6", key: "svg-2" }],
  ["path", { d: "M11 15v4.5a1.5 1.5 0 0 0 3 0v-4.5", key: "svg-3" }],
  ["path", { d: "M20 15h-3v6h3", key: "svg-4" }],
  ["path", { d: "M17 18h2", key: "svg-5" }]
]);

export { IconFileTypeVue as default };
//# sourceMappingURL=IconFileTypeVue.js.map
